import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateLocker, Locker, LockerListResponse, LockerQueryParams, UpdateLocker } from '@frontend/locker/types';

export class LockerClient extends APIClient {
    public static readonly endpoint = '/locker-api/v1';

    public static async fetchLockers(queryParams?: ApiQueryParams<DefaultQueryParams | LockerQueryParams>): Promise<LockerListResponse> {
        return await this.apiPaginated<LockerListResponse, DefaultQueryParams | LockerQueryParams>(`${this.endpoint}/lockers`, queryParams);
    }

    public static async resolveLockers(ids: string[]): Promise<LockerListResponse> {
        const response = await this.post(`${this.endpoint}/lockers-resolve`, { ids: ids });
        return this.handleResponse<LockerListResponse>(response);
    }

    public static async deleteLockers(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/lockers-delete`, { ids: ids });
        return this.handleVoidResponse(response);
    }

    public static async postLocker(accountId: string, iotId: string, deviceId: string, body: CreateLocker): Promise<Locker> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers`, body);
        return this.handleResponse<Locker>(response);
    }

    public static async fetchLocker(accountId: string, iotId: string, deviceId: string, lockerId: string): Promise<Locker> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers/${lockerId}`);
        return this.handleResponse<Locker>(response);
    }

    public static async patchLocker(accountId: string, iotId: string, deviceId: string, lockerId: string, body: UpdateLocker): Promise<Locker> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers/${lockerId}`, body);
        return this.handleResponse<Locker>(response);
    }

    public static async deleteLocker(accountId: string, iotId: string, deviceId: string, lockerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/devices/${deviceId}/lockers/${lockerId}`);
        return this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
